"use client";

import { type MouseEvent, useState } from "react";
import { useLanguage } from "~/translations/loader/use-language";

interface ShowMoreListProps {
  list: string[];
  /** max length in characters */
  maxLength: number;
  separator?: string;
}

export function ShowMoreList({
  list,
  maxLength,
  separator = ", ",
}: ShowMoreListProps) {
  const [expanded, setExpanded] = useState(false);
  const t = useLanguage();

  if (expanded) {
    return <>{list.join(separator)}</>;
  }

  let length = 0;
  const shownItems: string[] = [];
  const hiddenItems: string[] = [];

  for (const item of list) {
    length += item.length;

    if (length < maxLength) {
      shownItems.push(item);
    } else {
      hiddenItems.push(item);
    }
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setExpanded(true);
  };

  return (
    <span>
      {shownItems.join(separator)}
      {hiddenItems.length > 0 && (
        <>
          {separator}
          {"... "}
          <button
            aria-expanded="false"
            className="text-primary hover:underline"
            onClick={handleClick}
            type="button"
          >
            + {hiddenItems.length} {t.joblist_locations_showMore || "more"}
          </button>
        </>
      )}
    </span>
  );
}
